import React from "react";
import { ThemeProvider } from "@material-ui/core";
import { createOrganizeTheme } from "./OrganizeTheme";
import withAuthorization from "../../auth/withAuthorization";
import { Switch, Redirect, Route, useRouteMatch } from "react-router-dom";
import { useSnackAlert } from "../../common/use-snackAlert";
import { OrganizeProvider } from "./OrganizeProvider";
import { OrganizeContextMenuProvider } from "./OrganizeContextMenuProvider";
import { creatorRoles } from "../CreatorApplication";

import OrganizeView from "./OrganizeView";

const AuthorizedRoute = withAuthorization(Route);

const Organize = () => {
  const SnackAlertHandler = useSnackAlert();
  const { path } = useRouteMatch();
  return (
    <ThemeProvider theme={createOrganizeTheme}>
      <OrganizeProvider>
        <OrganizeContextMenuProvider>
          <Switch>
            <AuthorizedRoute exact path={path} roles={creatorRoles}>
              <OrganizeView SnackAlertHandler={SnackAlertHandler} />
            </AuthorizedRoute>

            <AuthorizedRoute roles={creatorRoles}>
              <Redirect to="/creator/organize?view=review,pending" />
            </AuthorizedRoute>
          </Switch>
        </OrganizeContextMenuProvider>
      </OrganizeProvider>
    </ThemeProvider>
  );
};

export default Organize;
